import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, Tab } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IRRIGATION_NAME } from '../../../constants/graphs';
import ConversationsTab from '../ConversationTab';
import useStyles from '../styles';
import { ModalState, EMPTY_MODAL_STATE } from '../chartModal';
import useIsClientOperator from '../../../hooks/useIsClientOperator';

const IrrigationConfigContent = ({
  sectorId,
  setModalState: setModalStateProp,
  refreshCounter = 0,
}: {
  sectorId: string;
  setModalState?: React.Dispatch<React.SetStateAction<ModalState>>;
  refreshCounter?: number;
}) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  // Default to the conversations tab when arriving from a notification (date param).
  const date = queryParams.get('date');
  const initialTabValue = date ? '2' : '1';

  const [tabValue, setTabValue] = useState(initialTabValue);

  const [, setInternalModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const setModalState = setModalStateProp ?? setInternalModalState;

  const isClientOperator = useIsClientOperator();

  useEffect(() => {
    if (isClientOperator && tabValue === '1') {
      setTabValue('2');
    }
  }, [isClientOperator, tabValue]);

  const handleTabChange = useCallback((event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  }, []);

  return (
    <TabContext value={tabValue}>
      <Box sx={{ borderBottom: 0 }}>
        <TabList onChange={handleTabChange} aria-label="sector tabs">
          <Tab label="Alertas" value="1" className={classes.tabLabel} />
          <Tab label="Conversaciones" value="2" className={classes.tabLabel} />
        </TabList>
      </Box>
      <TabPanel value="1" className={classes.configTabPanel}>
        In progress
      </TabPanel>
      <TabPanel value="2" className={classes.configTabPanel}>
        <ConversationsTab
          setModalState={setModalState}
          sectorId={sectorId}
          chartName={IRRIGATION_NAME}
          refreshCounter={refreshCounter}
        />
      </TabPanel>
    </TabContext>
  );
};

export default IrrigationConfigContent;
